




















































































import { Component } from 'vue-property-decorator';
import SearchResultsBaseComponent from '@/components/SearchResults/SearchResultsBaseComponent.vue';
import CategoriesSliderComponent from '@/components/SearchResults/CategoriesSliderComponent.vue';
import ExternalSliderComponent from '@/components/SearchResults/ExternalSliderComponent.vue';
import SearchResultElement from '@/models/SearchResultElement';
import { BaseGetter, FilterGetter, SearchGetter } from '@/store/getters';
import { SearchAction } from '@/store/actions';
import NoResultsComponent from '@/components/SearchResults/NoResultsComponent.vue';
import HtmlDataHelper from '@/helpers/HtmlDataHelper';
import DataLayerActionType from '@/types/DataLayerActionType';
import DataLayerClickTarget from '@/types/DataLayerClickTarget';
import TileTrackerHelper from '@/helpers/TileTrackerHelper';

@Component({
  name: 'product-grid-new-component',
  computed: {
    HtmlDataHelper() {
      return HtmlDataHelper;
    },
  },
  components: {
    'no-results-component': NoResultsComponent,
    'categories-slider-component': CategoriesSliderComponent,
    'external-slider-component': ExternalSliderComponent,
  },
})
export default class ProductGridNewComponent extends SearchResultsBaseComponent {
  get externalSearchResults(): Array<SearchResultElement> {
    return this.$store.getters[SearchGetter.ExternalSearchResults].length
      ? this.$store.getters[SearchGetter.ExternalSearchResults]
      : this.$store.getters[SearchGetter.ExternalSearchResults].elements;
  }

  get productsSearchResults(): Array<SearchResultElement> {
    return this.$store.getters[SearchGetter.ProductSearchResults].length
      ? this.$store.getters[SearchGetter.ProductSearchResults]
      : this.$store.getters[SearchGetter.ProductSearchResults].elements;
  }

  get categoriesSearchResults(): Array<SearchResultElement> {
    return this.$store.getters[SearchGetter.CategoriesSearchResults].length
      ? this.$store.getters[SearchGetter.CategoriesSearchResults]
      : this.$store.getters[SearchGetter.CategoriesSearchResults].elements;
  }

  get productsIsLoading(): boolean {
    return this.$store.getters[SearchGetter.ProductsIsLoading];
  }

  get categoriesIsLoading(): boolean {
    return this.$store.getters[SearchGetter.CategoriesIsLoading];
  }

  get externalsIsLoading(): boolean {
    return this.$store.getters[SearchGetter.ExternalIsLoading];
  }

  get isLoading(): boolean {
    return this.$store.getters[SearchGetter.IsLoading];
  }

  get totalResults(): number {
    return this.$store.getters[SearchGetter.TotalNumberOfResults];
  }

  get showShowMore(): boolean {
    return !this.productsIsLoading
      && this.$store.getters[SearchGetter.ProductSearchResults].length
      // eslint-disable-next-line max-len
      && this.$store.getters[SearchGetter.ProductSearchResults].length < this.$store.getters[SearchGetter.ProductTotalNumberOfResults];
  }

  private tileTracker = new TileTrackerHelper(new HtmlDataHelper());

  private gridNewResultClick(searchResult: SearchResultElement, index: number) {
    if (searchResult.type === 'product') {
      this.tileTracker.sendGoogleDataLayer({
        event: 'eec.productClick',
        ecommerce: {
          currencyCode: 'currencyCode',
          click: {
            actionField: {
              list: `resultpage|mainProductCollection|${this.hasFilters()}`,
            },
            products: [{
              category: HtmlDataHelper.createAnalyticsCategory(searchResult),
              name: `${searchResult.itemId}|${searchResult.title}`,
              position: index,
            }],
          },
        },
      });
    } else {
      this.tileTracker.sendGoogleDataLayer({
        event: 'eec.promotionClick',
        ecommerce: {
          promoClick: {
            promotions: [
              {
                id: `resultpage|mainProductCollection|${this.hasFilters()}`,
                name: `${searchResult.itemId}|${searchResult.title}`,
                creative: searchResult.urlPath,
                position: index,
              },
            ],
          },
        },
      });
    }
  }

  private showMore() {
    if (!this.isLoading) {
      this.$store.dispatch(SearchAction.ProductLoadMore).then(() => {
        this.tileTracker.sendGoogleDataLayer({
          event: 'siteSearch',
          siteSearchUrl: `/${this.$store.getters[BaseGetter.Country]}/search/${this.$store.getters[FilterGetter.ActiveSearchContext]}?searchterm=${encodeURIComponent(this.$store.getters[SearchGetter.SearchTerm])}&searchcat=resultpage`,
          actionType: DataLayerActionType.CLICK,
          hasResults: this.$store.getters[SearchGetter.TotalNumberOfResults] > 0,
          suggestion: this.$store.getters[SearchGetter.SearchSuggestions].term.length > 0
            ? this.$store.getters[SearchGetter.SearchSuggestions].term
            : DataLayerClickTarget.NONE,
          clickTarget: {
            type: DataLayerClickTarget.SHOW_MORE_RESULTS,
            value: this.$store.getters[SearchGetter.SearchTerm],
          },
        });
      });
    }
  }

  private hasFilters() {
    let hasFilters = 'Not Filtered';
    if (this.$store.getters[FilterGetter.AppliedFilterOptions].size > 0) {
      hasFilters = 'Filtered';
    }
    return hasFilters;
  }
}
